export default "__VITE_ASSET__3dcf8c1e__"